import React, { useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CustomerReels = ({ userEmail }) => {
  const [yourFeedback, setYourFeedback] = useState([]);
  const [otherFeedbacks, setOtherFeedbacks] = useState([]);
  const [name, setName] = useState("");
  const [feedback, setFeedback] = useState("");
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetch("https://yaasaai.com/myphpapi/get_feedback.php")
      .then((res) => res.json())
      .then((data) => {
        const yours = data.filter((item) => item.name === userEmail);
        setYourFeedback(yours);
      });

    fetch("https://yaasaai.com/myphpapi/get_old_feedback.php")
      .then((res) => res.json())
      .then((data) => {
        const others = data.filter((item) => item.name !== userEmail);
        setOtherFeedbacks(others);
      });
  }, [userEmail]);

  //tracking script
  window.gtag("event", "feedback_check ", {
    screen_name: "checkout screen visited",
    phone: userEmail,
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith("image/")) {
      setImage(file);
    } else {
      setImage(null);
      Swal.fire(
        "⚠️ Invalid File",
        "Please select a valid image file (JPG, PNG, etc.)",
        "error"
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🚫 Step 1: Check if feedback already exists
    if (yourFeedback.length > 0) {
      const lastReview = yourFeedback[0];
      const [day, month, year] = lastReview.date_of_review
        .split(" ")[0]
        .split("-"); // "06-07-2025" → [06,07,2025]
      const reviewDate = new Date(`${year}-${month}-${day}`);

      const today = new Date();
      const isSameDay =
        reviewDate.getDate() === today.getDate() &&
        reviewDate.getMonth() === today.getMonth() &&
        reviewDate.getFullYear() === today.getFullYear();

      if (isSameDay) {
        Swal.fire("⏳ आपने आज पहले ही फीडबैक दिया है। कृपया कल फिर से दें।");
        return;
      }
    }

    // 🟡 Step 2: Check required fields
    if (!name || !feedback || !image) {
      Swal.fire("⚠️ कृपया सभी फ़ील्ड भरें और एक फ़ोटो चुनें।");
      return;
    }

    const formData = new FormData();
    formData.append("phone", userEmail);
    formData.append("name", name);
    formData.append("feedback", feedback);
    formData.append("image", image);

    try {
      const res = await fetch(
        "https://yaasaai.com/myphpapi/verify_feedback.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const raw = await res.text();
      console.log("RAW:", raw);

      try {
        const data = JSON.parse(raw);
        if (data.success) {
          Swal.fire("✅ Uploaded!", "Thanks for your feedback!", "success");

          // Step 3: Reset form
          setName("");
          setFeedback("");
          setImage(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }

          // Step 4: Show feedback instantly
          setYourFeedback((prev) => [data.newFeedback, ...prev]);

          // ✅ Step 5: Re-fetch other feedbacks so latest appears in list
          await fetch("https://yaasaai.com/myphpapi/get_old_feedback.php")
            .then((res) => res.json())
            .then((data) => {
              const others = data.filter((item) => item.name !== userEmail);
              setOtherFeedbacks(others);
            });

          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          Swal.fire(
            "❌ Not Allowed",
            data.message || "Server blocked your feedback",
            "error"
          );
        }
      } catch (err) {
        console.error("JSON Parse Error:", raw);
        Swal.fire("Error", "Invalid server response", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
      console.error("Network Error:", err);
    }
  };

  return (
    <div
      className="container-fluid px-2 px-sm-4 py-4"
      style={{ maxWidth: "1200px", margin: "0 auto" }}
    >
      <h3 className="text-center mb-4 text-success fw-bold">📸 ग्राहक अनुभव</h3>

      <div className="container px-2 px-sm-4">
        <div
          className="card shadow-sm p-3 p-md-4 mb-4"
          style={{
            borderRadius: "12px",
            width: "100%",
            maxWidth: "800px", // keeps it elegant on large screens
            margin: "0 auto",
            border: "1px solid green",
            borderRadius: "0.75rem",
          }}
        >
          <h6
            className="mb-3 text-center"
            style={{
              backgroundColor: "#fff8f2",
              color: "green",
              fontWeight: "600",
              letterSpacing: "0.5px",
            }}
          >
            ✍️ अपनी समीक्षा साझा करें
          </h6>

          <form
            onSubmit={handleSubmit}
            style={{
              backgroundColor: "#fff8f2", // soft warm apricot background

              padding: "1rem",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* नाम */}
            <div className="mb-2 row align-items-center">
              <label
                className="col-3 col-sm-6 col-form-label col-form-label-sm fw-semibold"
                style={{ fontSize: "13px", color: "#cc4e3d" }}
              >
                नाम:
              </label>
              <div className="col-9 col-sm-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="आपका नाम"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={{ border: "1px solid coral", borderRadius: "0.4rem" }}
                />
              </div>
            </div>

            {/* अनुभव */}
            <div className="mb-2 row align-items-center">
              <label
                className="col-3 col-sm-6 col-form-label col-form-label-sm fw-semibold"
                style={{ fontSize: "13px", color: "#cc4e3d" }}
              >
                अनुभव:
              </label>
              <div className="col-9 col-sm-6">
                <textarea
                  className="form-control form-control-sm"
                  placeholder="आपका अनुभव"
                  rows={1}
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  style={{
                    resize: "none",
                    border: "1px solid coral",
                    borderRadius: "0.4rem",
                  }}
                />
              </div>
            </div>

            {/* फ़ोटो */}
            <div className="mb-3 row align-items-center">
              <label
                className="col-3 col-form-label col-form-label-sm fw-semibold"
                style={{ fontSize: "13px", color: "#cc4e3d" }}
              >
                फ़ोटो:
              </label>
              <div className="col-9">
                <input
                  type="file"
                  className="form-control form-control-sm"
                  accept="image/*"
                  ref={fileInputRef} // ← added
                  onChange={handleImageChange}
                  style={{ border: "1px solid coral", borderRadius: "0.4rem" }}
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn w-100 btn-sm"
              style={{
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
                borderRadius: "0.5rem",
                letterSpacing: "0.5px",
              }}
            >
              🚀 फीडबैक सबमिट करें
            </button>
          </form>
        </div>
      </div>

      {/* Your Feedback */}
      {yourFeedback.length > 0 && (
        <>
          <h5
            className="fw-bold text-dark mt-2 mb-3 text-center"
            style={{
              background: "#e6f4ea", // soft fresh green
              borderRadius: "0.5rem",
              padding: "0.5rem 1rem",
            }}
          >
            🌟 आपकी प्रतिक्रिया
          </h5>
          <div className="row">
            {yourFeedback.map((item) => (
              <div className="col-12 col-sm-2 col-lg-4 mb-3" key={item.id}>
                <div
                  className="card shadow-sm h-100 p-1 w-100"
                  style={{
                    border: "1.5px solid coral",
                    borderRadius: "0.75rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      gap: "1rem",
                      flexWrap: "wrap", // responsive
                    }}
                  >
                    {/* Image Section */}
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "10%",
                        objectFit: "cover",
                        transition: "transform 0.3s ease-in-out",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "scale(2.5)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />

                    {/* Name + Feedback Section */}
                    <div style={{ flex: 1, minWidth: "200px" }}>
                      {/* Name on top right of image */}
                      <div
                        style={{
                          textAlign: "center",
                          marginBottom: "0.25rem",
                        }}
                      >
                        <h6
                          style={{
                            width: "100%",
                            borderRadius: "0.5rem",
                            background: "green",
                            color: "white",
                            padding: "0.2rem",
                            fontSize: "0.7rem",
                            display: "inline-block",
                          }}
                        >
                          {item.name}
                        </h6>
                      </div>

                      {/* Feedback Section */}
                      <div
                        style={{
                          backgroundColor: "#fff8f2",
                          borderLeft: "4px solid coral",
                          borderRadius: "0.5rem",
                          padding: "0.75rem 1rem",
                          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
                          fontSize: "0.85rem",
                          color: "#7a3e2f",
                          lineHeight: "1.3",
                          wordWrap: "break-word",
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "0.4rem",
                        }}
                      >
                        <span style={{ fontSize: "1rem" }}>📝</span>
                        <span>{item.feedback}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Other Feedbacks */}
      <h5
        className="fw-bold text-dark mt-2 mb-3 text-center"
        style={{
          background: "#e6f4ea", // soft fresh green
          borderRadius: "0.5rem",
          padding: "0.5rem 1rem",
        }}
      >
        👥 अन्य ग्राहक
      </h5>

      <div className="row">
        {otherFeedbacks.map((item) => (
          <div className="col-12 col-sm-2 col-lg-4 mb-3" key={item.id}>
            <div
              className="card shadow-sm h-100 p-1 w-100"
              style={{
                border: "1.5px solid coral",
                borderRadius: "0.75rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  gap: "1rem",
                  flexWrap: "wrap", // responsive
                }}
              >
                {/* Image Section */}
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "10%",
                    objectFit: "cover",
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(2.5)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />

                {/* Name + Feedback Section */}
                <div style={{ flex: 1, minWidth: "200px" }}>
                  {/* Name on top right of image */}
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "0.25rem",
                    }}
                  >
                    <h6
                      style={{
                        width: "100%",
                        borderRadius: "0.5rem",
                        background: "green",
                        color: "white",
                        padding: "0.2rem",
                        fontSize: "0.7rem",
                        display: "inline-block",
                      }}
                    >
                      {item.name}
                    </h6>
                  </div>

                  {/* Feedback Section */}
                  <div
                    style={{
                      backgroundColor: "#fff8f2",
                      borderLeft: "4px solid coral",
                      borderRadius: "0.5rem",
                      padding: "0.75rem 1rem",
                      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
                      fontSize: "0.85rem",
                      color: "#7a3e2f",
                      lineHeight: "1.3",
                      wordWrap: "break-word",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.4rem",
                    }}
                  >
                    <span style={{ fontSize: "1rem" }}>📝</span>
                    <span>{item.feedback}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Back Button */}
      <div className="text-center mt-4">
        <button
          className="btn btn-outline-success px-4"
          onClick={() => navigate("/")}
        >
          ← होम पेज पर जाएँ
        </button>
      </div>
    </div>
  );
};

export default CustomerReels;
